<template>
  <div class="guangfu-tongyi">
    <div class="con">
      <div class="Files-top">
        <div class="ic-left">
          <span>效率评估</span>
        </div>
        <div class="btns">
          <el-button type="primary" class="last-el-button">导出</el-button>
        </div>
      </div>
      <div class="search-input-btn" style="width:100%">
        <div class="input-small ">
          <span>时间：</span>
          <el-date-picker v-model="value2" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <el-button type="primary" plain class="search-btn">查询</el-button>
      </div>
      <div class="myteble">
        <el-table :data="tableData" stripe style="width: 100%" :height="heights">
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无效率评估数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="测量点"> </el-table-column>
          <el-table-column prop="timer" label="6-20"> </el-table-column>
          <el-table-column prop="timer2" label="6-21"> </el-table-column>
          <el-table-column prop="timer3" label="6-22"> </el-table-column>
          <el-table-column prop="timer4" label="6-23"> </el-table-column>
          <el-table-column prop="timer5" label="6-24"> </el-table-column>
          <el-table-column prop="timer6" label="6-25"> </el-table-column>
          <el-table-column prop="timer7" label="6-26"> </el-table-column>
          <el-table-column prop="timer8" label="6-27"> </el-table-column>
        </el-table>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'WedoWebEleEfficiency',

    data () {
      return {
        tableData: [],
        value2: [1687190400000,1687795200000],
        options: [{
          value: 'date',
          label: '日'
        },{
          value: 'month',
          label: '月'
        },{
          value: 'year',
          label: '年'
        }],
        value: 'date',
        heights: document.getElementById('app').clientHeight-250,//屏幕高度 - 导航栏高度
      };
    },

    mounted () {

    },

    methods: {

    },
  };
</script>

<style lang="scss" scoped>
  .guangfu-tongyi {}
</style>